import { AccordionItem } from '@scripts/accordion/classes/AccordionItem.js';

export class Accordion {
    /**
     * @type {Element}
     * @private
     */
    _active = null;

    /**
     * @type {AccordionItem[]}
     * @private
     */
    _items = [];

    /**
     * @type {HTMLElement}
     * @private
     */
    _domElm;

    /**
     * @type {HTMLElement}
     * @private
     */
    _itemsElm;

    set active (active) {
        this._active = active;

        this.update();
    }

    get active () {
        return this._active;
    }

    get domElm () {
        return this._domElm;
    }

    set domElm (value) {
        this._domElm = value;
    }

    get itemsElm () {
        return this._itemsElm;
    }

    set itemsElm (value) {
        this._itemsElm = value;
    }

    get items () {
        return this._items;
    }

    set items (value) {
        this._items = value;
    }

    constructor (domElm) {
        this.domElm = domElm;

        this.itemsElm = this.domElm.querySelectorAll('.accordion-item');

        this.init();
    }

    init () {
        this.items = Array.from(this.itemsElm).map((item) => {
            return new AccordionItem(this, item);
        });
    }

    update () {
        this.items.forEach((item) => {
            item.open = item.domElm === this.active;
        });
    }
}
